/* Product image viewer. Native dialog keeps focus and places photos above widgets. */
(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('.dm-gallery').forEach(function (gallery) {
      var track = gallery.querySelector('[data-dm-track]');
      var trigger = gallery.querySelector('.dm-gallery__zoom');
      var slides = Array.from(gallery.querySelectorAll('[data-dm-zoom-src]'));
      if (!track || !trigger || !slides.length || gallery.dataset.dmZoomReady) return;
      if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      gallery.dataset.dmZoomReady = 'true';
      var dialog = document.createElement('dialog');
      dialog.className = 'dm-image-viewer';
      dialog.setAttribute('aria-label', 'Fotos del producto');
      dialog.innerHTML = '<div class="dm-image-viewer__bar"><span>Fotos del producto</span><button type="button" class="dm-image-viewer__close" aria-label="Cerrar fotos" autofocus>×</button></div><div class="dm-image-viewer__stage"><img class="dm-image-viewer__image" alt="" draggable="false"></div><div class="dm-image-viewer__nav"><button type="button" data-prev aria-label="Foto anterior">←</button><span data-counter aria-live="polite" aria-atomic="true"></span><button type="button" data-next aria-label="Foto siguiente">→</button><button type="button" data-zoom aria-label="Ampliar foto" aria-pressed="false">Ampliar</button></div>';
      gallery.appendChild(dialog);
      var stage = dialog.querySelector('.dm-image-viewer__stage');
      var img = dialog.querySelector('img');
      var zoom = dialog.querySelector('[data-zoom]');
      var index = 0, scale = 1, x = 0, y = 0, origin = null, scrollY = 0;
      var oldBodyStyle = null, oldRootOverflow = '', lastTap = 0;
      var pointers = new Map(), gesture = null, suppressTap = false;
      dialog.querySelector('[data-prev]').hidden = slides.length < 2;
      dialog.querySelector('[data-next]').hidden = slides.length < 2;
      function paint() {
        scale = Math.max(1, Math.min(4, scale));
        // Clamp pan to the actual contained image, rather than its surrounding whitespace.
        var fit = Math.min(stage.clientWidth / (img.naturalWidth || 1), stage.clientHeight / (img.naturalHeight || 1));
        var maxX = Math.max(0, ((img.naturalWidth || 1) * fit * scale - stage.clientWidth) / 2);
        var maxY = Math.max(0, ((img.naturalHeight || 1) * fit * scale - stage.clientHeight) / 2);
        x = Math.max(-maxX, Math.min(maxX, x));
        y = Math.max(-maxY, Math.min(maxY, y));
        img.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')';
        stage.dataset.zoomed = String(scale > 1);
        zoom.textContent = scale > 1 ? 'Reducir' : 'Ampliar';
        zoom.setAttribute('aria-label', scale > 1 ? 'Reducir foto' : 'Ampliar foto');
        zoom.setAttribute('aria-pressed', String(scale > 1));
      }
      function resetZoom() { scale = 1; x = 0; y = 0; lastTap = 0; paint(); }
      function showImage(i) {
        index = (i + slides.length) % slides.length;
        img.src = slides[index].dataset.dmZoomSrc;
        img.alt = slides[index].getAttribute('aria-label') || 'Foto del producto';
        dialog.querySelector('[data-counter]').textContent = (index + 1) + ' / ' + slides.length;
        resetZoom();
      }
      function open(i, source) {
        if (window.dmOverlay) window.dmOverlay.close();
        origin = source;
        scrollY = window.scrollY;
        oldBodyStyle = document.body.getAttribute('style');
        oldRootOverflow = document.documentElement.style.overflow;
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollY + 'px';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        showImage(i);
        dialog.showModal();
      }
      dialog.addEventListener('close', function () {
        pointers.clear(); gesture = null;
        if (oldBodyStyle === null) document.body.removeAttribute('style');
        else document.body.setAttribute('style', oldBodyStyle);
        document.documentElement.style.overflow = oldRootOverflow;
        window.scrollTo({ top: scrollY, behavior: 'instant' });
        if (origin && document.contains(origin)) origin.focus({ preventScroll: true });
      });
      dialog.querySelector('.dm-image-viewer__close').addEventListener('click', function () { dialog.close(); });
      dialog.querySelector('[data-prev]').addEventListener('click', function () { showImage(index - 1); });
      dialog.querySelector('[data-next]').addEventListener('click', function () { showImage(index + 1); });
      zoom.addEventListener('click', function () { scale = scale > 1 ? 1 : 2.5; x = 0; y = 0; paint(); });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); showImage(index + (e.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        open(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), trigger);
      });
      slides.forEach(function (slide, i) {
        slide.setAttribute('role', 'button');
        slide.setAttribute('tabindex', '0');
        slide.setAttribute('aria-haspopup', 'dialog');
        slide.addEventListener('click', function () { open(i, slide); });
        slide.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i, slide); }
        });
      });
      function startGesture() {
        var points = Array.from(pointers.values());
        gesture = { scale: scale, x: x, y: y, points: points.map(function (p) { return { x: p.x, y: p.y }; }) };
        if (points.length > 1) gesture.distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
      }
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        stage.setPointerCapture(e.pointerId);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 1) suppressTap = false;
        else suppressTap = true;
        startGesture();
      });
      stage.addEventListener('pointermove', function (e) {
        if (!pointers.has(e.pointerId) || !gesture) return;
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        var points = Array.from(pointers.values());
        if (points.length > 1 && gesture.distance) {
          scale = gesture.scale * Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y) / gesture.distance;
          x = gesture.x + (points[0].x + points[1].x - gesture.points[0].x - gesture.points[1].x) / 2;
          y = gesture.y + (points[0].y + points[1].y - gesture.points[0].y - gesture.points[1].y) / 2;
        } else if (points.length === 1) {
          var dx = points[0].x - gesture.points[0].x, dy = points[0].y - gesture.points[0].y;
          if (Math.hypot(dx, dy) > 12) suppressTap = true;
          if (scale > 1) { x = gesture.x + dx; y = gesture.y + dy; }
        }
        paint();
      });
      function endPointer(e) {
        if (!pointers.has(e.pointerId)) return;
        if (e.type === 'pointerup' && pointers.size === 1 && gesture) {
          var dx = e.clientX - gesture.points[0].x, dy = e.clientY - gesture.points[0].y;
          if (scale === 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) showImage(index + (dx < 0 ? 1 : -1));
          else if (!suppressTap) {
            var now = Date.now();
            if (now - lastTap < 300) { scale = scale > 1 ? 1 : 2.5; x = 0; y = 0; paint(); lastTap = 0; }
            else lastTap = now;
          }
        }
        pointers.delete(e.pointerId);
        if (pointers.size) startGesture(); else gesture = null;
      }
      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);
      img.addEventListener('load', paint);
      window.addEventListener('resize', function () { if (dialog.open) paint(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
